import { useMemo } from 'react';
import styled from '@emotion/styled';

import { useDevice } from '../../../store/devices/useDevices.ts';

import { su } from '../../../theme/functions/su';

import { Heading3Bold } from '../../../components/common/text/Heading3Bold';
import { DeviceSettingsMaintenanceAction } from './DeviceSettingsMaintenanceAction';

export function DeviceSettingsMaintenance(props) {
  const { device } = useDevice({
    deviceId: props.deviceId,
  });

  const maintenanceCapabilitiesList = useMemo(() => {
    return Object.values(device?.capabilitiesObj ?? {}).filter((capabilityObj) => {
      if (capabilityObj.id.startsWith('button') === false) {
        return false;
      }

      return (
        capabilityObj.maintenanceAction === true ||
        capabilityObj.options?.maintenanceAction === true
      );
    });
  }, [device?.capabilitiesObj]);

  if (maintenanceCapabilitiesList.length === 0 || device == null) {
    return null;
  }

  return (
    <S.Root>
      <Heading3Bold>Maintenance</Heading3Bold>

      {maintenanceCapabilitiesList.map((capability) => {
        return (
          <DeviceSettingsMaintenanceAction
            key={capability.id}
            capabilityId={capability.id}
            deviceId={device.id}
          />
        );
      })}
    </S.Root>
  );
}

function S() {}
DeviceSettingsMaintenance.S = S;

S.Root = styled.div`
  ${Heading3Bold.S.Root} {
    margin: ${su(4, 0, 2)};
  }
`;
